import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static values = {
		target: String,
	}

	connect() {
		this.element.collapseElementHidden = false
		this.element.querySelector('.while-elements-hidden').classList.add('d-none')
	}

	toggle(event) {
		if (this.element.collapseElementHidden) {
			this.element.querySelector('.while-elements-shown').classList.remove('d-none')
			this.element.querySelector('.while-elements-hidden').classList.add('d-none')
			for (const element of document.querySelectorAll(this.targetValue)) {
				element.classList.remove('d-none')
			}
			this.element.collapseElementHidden = false
		} else {
			this.element.querySelector('.while-elements-shown').classList.add('d-none')
			this.element.querySelector('.while-elements-hidden').classList.remove('d-none')
			for (const element of document.querySelectorAll(this.targetValue)) {
				element.classList.add('d-none')
			}
			this.element.collapseElementHidden = true
		}
	}
}
